import "./index.scss";
jQuery(document).ready(function ($) {
    var $redeemBlock = $("#agcfw-redeem-gift-card");
    var Funcs = {
        initPopover: function () {
            $(".agcfw-tooltip").each(function () {
                // @ts-ignore
                $(this).webuiPopover({
                    // @ts-ignore
                    title: $(this).data("title"),
                    // @ts-ignore
                    content: $(this).data("content"),
                    width: 250,
                    closable: true,
                    animation: "pop",
                    padding: false,
                    placement: "bottom-right",
                });
            });
        },
        initBlockMaxHeight: function () {
            var $redeemBlock = $("#agcfw-redeem-gift-card");
            if (!$redeemBlock.hasClass("agcfw-toggle-redeem-form"))
                return;
            var blockHeight = $redeemBlock.find(".agcfw-inner-content").height() +
                2 *
                    parseInt(getComputedStyle($redeemBlock.find(".agcfw-inner-content")[0])
                        .fontSize);
            $redeemBlock.find(".agcfw-inner").css({ maxHeight: blockHeight });
        },
        submitRedeemForm: function (e) {
            var $form = $(this).closest(".agcfw-redeem-gift-card-form");
            var $giftCode = $(this).siblings("input.gift_card_code");
            var isCheckout = $form.data("is_checkout");
            $form.find("input,button").prop("disabled", true);
            if (isCheckout) {
                Funcs.blockCheckout();
            }
            $.post(woocommerce_params.ajax_url, {
                action: "agcfw_redeem_gift_card",
                gift_card_code: $giftCode.val(),
                _wpnonce: $form.data("nonce"),
            }, function (response) {
                if (isCheckout) {
                    Funcs.unblockCheckout();
                    $(document.body).trigger("update_checkout", {
                        update_shipping_method: false,
                    });
                }
                else {
                    window.location.reload();
                }
            }, "json").always(function () {
                $giftCode.val("");
                $form.find("input,button").prop("disabled", false);
            });
        },
        toggleFormButton: function () {
            var $this = $(this);
            var $button = $this.siblings(".button");
            // disable when input has no value, enable when it has.
            $button.prop("disabled", !$this.val());
        },
        blockCheckout: function () {
            $(".woocommerce form.woocommerce-checkout")
                .addClass("processing")
                .block({
                message: null,
                overlayCSS: {
                    background: "#fff",
                    opacity: 0.6,
                },
            });
        },
        unblockCheckout: function () {
            $(".woocommerce-error, .woocommerce-message").remove();
            $(".woocommerce form.woocommerce-checkout")
                .removeClass("processing")
                .unblock();
        },
        toggleShowCheckoutRedeemForm: function () {
            $redeemBlock.toggleClass("show");
        },
        // Wait Execution until element is visible
        waitForVisibleElement: function (selector) {
            return new Promise(function (resolve) {
                var checkVisibility = setInterval(function () {
                    var el = document.querySelector(selector);
                    if (el && el.offsetWidth > 0 && el.offsetHeight > 0) {
                        clearInterval(checkVisibility);
                        resolve(el);
                    }
                }, 100);
            });
        }
    };
    $redeemBlock.on("keyup", ".agcfw-redeem-gift-card-form input.gift_card_code", Funcs.toggleFormButton);
    $redeemBlock.on("click", ".agcfw-redeem-gift-card-form button", Funcs.submitRedeemForm);
    $redeemBlock.on("click", "h3", Funcs.toggleShowCheckoutRedeemForm);
    Funcs.initPopover();
    /**
     * if oceanwp multi-checkout page option is enabled
     * @page checkout
     * @option multi-checkout
     * */
    if (jQuery('#owp-checkout-timeline')) {
        // Execute after element is visible
        Funcs.waitForVisibleElement('#agcfw-redeem-gift-card').then(function () {
            Funcs.initBlockMaxHeight();
        });
    }
    else { // if oceanwp multi-checkout page option is disabled
        Funcs.initBlockMaxHeight();
    }
});
